import { application } from "../controllers/application"
import "@hotwired/turbo-rails"
import { registerControllers } from "stimulus-vite-helpers"
import { Modal } from "tailwindcss-stimulus-components"

// Só os controllers das páginas públicas (blog, eventos, checkout).
// Os do admin (tom-select, flatpickr, tinymce, autosave...) vêm por controllers/index.js.
// Controller files must be named *_controller.js.
const controllers = import.meta.glob([
  "./blog/*_controller.js",
  "./youtube_lazy_controller.js",
  "./newsletter_controller.js",
  "./extended_modal_controller.js",
  "./clipboard_controller.js",
  "./dynamic_select_controller.js",
  "./foreigner_controller.js",
  "./masks_controller.js",
  "./nested_form_controller.js",
  "./phone_controller.js",
], { eager: true })
registerControllers(application, controllers)

application.register("modal", Modal)
